import React from "react";
import ArticleItem from "../../components/articles/ArticleItem";

// titleJP, tags, paragraph, readMoreEnabled, readMoreLink
const articlesSection = ({ title, items, selectedTag, onClearFilter }) => {
  // When no tag is selected, render all articles.
  // Otherwise, keep only articles whose tags contain a matching `name_en`.
  const visibleItems = selectedTag
    ? items.filter((item) =>
        item.tags?.some((tag) => tag.name_en === selectedTag)
      )
    : items;

  return (
    <div className="article-view-section">
      <div className="container article-view-main">
        {selectedTag && (
          <div className="filter-banner">
            <span className="filter-info font-outfit">
              {visibleItems.length} article{visibleItems.length === 1 ? "" : "s"} tagged{" "}
              <strong>"{selectedTag}"</strong>
            </span>
            {onClearFilter && (
              <button
                type="button"
                onClick={onClearFilter}
                className="show-all-btn"
              >
                Show all articles ({items.length})
                <svg
                  className="show-all-caret"
                  width="16"
                  height="16"
                  viewBox="0 0 12 12"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M2.5 4.5l3.5 3.5 3.5-3.5"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            )}
          </div>
        )}
        <div className="article-title-view">
            <div className="article-item-view">
                {visibleItems.map((item, i) => {
                    const isLast = i === visibleItems.length - 1; // ✅ check if last item
                    return (
                    <ArticleItem
                        key={item._key || i + 1}
                        number={i + 1}
                        title_en={item.title}
                        title_jp={item.titleJP}
                        tags={item.tags} // dynamic array of tags
                        preview={item.preview}
                        content={item.paragraph}
                        type={i % 2 === 1} // ✅ true for every 2nd item (1, 3, 5…)
                        className={isLast ? "last-item" : ""}
                    />
                    );
                })}
            </div>
        </div>
      </div>
    </div>  
  );
};

export default articlesSection;